import { v4 as uuidv4 } from "uuid";
import { useListenFromRenderer } from "../message";
import { postToRenderer } from "../message/utils";
import { fetchGatewayInferenceJob } from "./shared/fetch-inference-job";
import { getTargetEditorImage } from "./shared/target-editor-image";

const TOOL_NAME = "Image to Image";

const callImgToImg = async (
	prompt: string,
	denoise: number,
	messageId: string,
	jwt: string,
	tool_document_id: string,
) => {
	const { success } = await getTargetEditorImage({
		commandName: TOOL_NAME,
		resultLayerName: TOOL_NAME,
		processImage: async ({ imageBase64, executionContext }) => {
			const data = {
				inputs: {
					$image: imageBase64,
					$prompt: prompt,
					$denoise: denoise,
				},
				jwt,
				tool_document_id,
			};
			return fetchImgToImg(data, executionContext, messageId);
		},
	});
	return success;
};

export async function fetchImgToImg(
	params: {
		inputs: {
			$image: string;
			$denoise: number;
			$prompt: string;
		};
		jwt: string;
		tool_document_id: string;
	},
	executionContext: any,
	messageId: string,
): Promise<string | false> {
	return fetchGatewayInferenceJob(params, executionContext, messageId);
}

export function useListenImgToImgMessage() {
	useListenFromRenderer([
		{
			key: "imgToImg",
			onMessage: async (message) => {
				const success = await callImgToImg(
					message.values.prompt,
					message.values.denoise,
					message.id,
					message.values.jwt,
					message.values.tool_document_id,
				);
				postToRenderer([
					{
						key: "finish",
						id: uuidv4(),
						values: {
							id: message.id,
							status: success ? "success" : "error",
						},
					},
				]);
			},
		},
	]);
}
